import {
  ComponentChildSchema,
  withCustomizeSchema,
} from '@nizza/customize-live';
import { useMemo } from 'react';
import { intlFormatMessageOutsideFC } from '../../utils/intlFormatMessageOutsideFC';

const intl = intlFormatMessageOutsideFC();

export const MessageAdminContainerDesktop = withCustomizeSchema(
  (
    props: ComponentChildSchema<
      React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
      > & { isAdmin: boolean }
    >,
  ) => {
    const { formData } = props;
    return (
      <div
        {...props}
        customize-field={props.selector}
        style={
          props.isAdmin
            ? {
                backgroundColor: formData?.data?.backgroundColorDesktop,
                color: formData?.data?.messageColorDesktop,
              }
            : {}
        }
      />
    );
  },
  {
    chat: {
      id: 'message_admin_desktop',
      label: intl.formatMessage({
        id: 'customize/message-container-admin.admin-message',
      }),
      category: 'desktop',
      fields: {
        type: 'object',
        properties: {
          backgroundColorDesktop: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/general.background',
            }),
            default: '#2c313c',
          },
          messageColorDesktop: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/general.message',
            }),
            default: '#ffffff',
          },
        },
      },
      ui: {
        backgroundColorDesktop: {
          'ui:widget': 'color',
        },
        messageColorDesktop: {
          'ui:widget': 'color',
        },
      },
    },
  },
);

export const MessageAdminContainerMobile = withCustomizeSchema(
  (
    props: ComponentChildSchema<
      React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
      > & { isAdmin: boolean; isVerticalLayout: boolean }
    >,
  ) => {
    const { formData, isAdmin, isVerticalLayout } = props;
    const style: React.CSSProperties = useMemo(() => {
      const messagesStyles: React.CSSProperties = {
        boxSizing: 'border-box',
        maxWidth: '100%',
      };
      if (!isAdmin || !formData?.data) return messagesStyles;
      const setStylesProperties = (backgroundColor: string, color: string) => {
        return Object.assign({}, messagesStyles, { backgroundColor, color });
      };

      const {
        backgroundColorMobileVertical,
        backgroundColorMobileHorizontal,
        messageColorMobileHorizontal,
        messageColorMobileVertical,
      } = formData.data;

      if (isVerticalLayout) {
        return setStylesProperties(
          backgroundColorMobileVertical,
          messageColorMobileVertical,
        );
      }

      return setStylesProperties(
        backgroundColorMobileHorizontal,
        messageColorMobileHorizontal,
      );
    }, [formData, isAdmin, isVerticalLayout]);

    return <div {...props} customize-field={props.selector} style={style} />;
  },
  {
    chat: {
      id: 'message_admin_mobile',
      label: intl.formatMessage({
        id: 'customize/message-container-admin.admin-message',
      }),
      category: 'mobile',
      fields: {
        type: 'object',
        properties: {
          backgroundColorMobileHorizontal: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/message-container-admin.background-layout-horizontal',
            }),
            default: '#fffc',
          },
          messageColorMobileHorizontal: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/message-container-admin.message-layout-horizontal',
            }),
            default: '#323845',
          },
          backgroundColorMobileVertical: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/message-container-admin.background-layout-vertical',
            }),
            default: 'rgba(255, 255, 255, 0.69)',
          },
          messageColorMobileVertical: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/message-container-admin.message-layout-vertical',
            }),
            default: '#323845',
          },
        },
      },
      ui: {
        backgroundColorMobileHorizontal: {
          'ui:widget': 'color',
        },
        messageColorMobileHorizontal: {
          'ui:widget': 'color',
        },
        backgroundColorMobileVertical: {
          'ui:widget': 'color',
        },
        messageColorMobileVertical: {
          'ui:widget': 'color',
        },
      },
    },
  },
);
